export default "assets/images/1354b4f40dd58bb0f2a4871cb4ff81d8.png";